/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ViewChild,
  ComponentFactoryResolver,
  ViewContainerRef,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  TemplateRef
} from '@angular/core';

import { TabComponent } from './tab.component';
import { DynamicTabsDirective } from './dynamic-tabs.directive';
import { BsModalService } from 'ngx-bootstrap';
import { UserService } from '../../common/services/User.service';
import { TicketService } from '../../common/services/Ticket.service';
import { SocketService } from '../../common/services/Socket.service';
import { OrganizeService } from '../../common/services/Organize.service';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from 'app/common/services/Group.service';

declare var $: any;

@Component({
  selector: 'my-tabs',
  templateUrl: './tabs.template.html',
  styleUrls: ['tabs.style.css'],
  providers: [UserService, TicketService, OrganizeService, GroupService]
})
export class TabsComponent implements AfterContentInit {
  dynamicTabs: TabComponent[] = [];
  public icon: any = 'edit';
  public modalRef: any;
  public message: { class: string, content: string } = null;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  @ViewChild(DynamicTabsDirective) dynamicTabPlaceholder: DynamicTabsDirective;
  @Output('clickTabFirst') clickTabFirst = new EventEmitter();

  @ViewChild('optionMenu') optionMenu: ElementRef;

  public user: any = {};
  public model: any = {};
  public modelOrganize: any = {};

  public list: any = [];
  public max : Number = 6;
  public allGroup : any = [];
  public is_load_data : boolean = false;
  /*
    Alternative approach of using an anchor directive
    would be to simply get hold of a template variable
    as follows
  */
  // @ViewChild('container', {read: ViewContainerRef}) dynamicTabPlaceholder;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private modalService: BsModalService,
    private userService: UserService,
    private ticketService: TicketService,
    private socketService: SocketService,
    private organizeService: OrganizeService,
    private groupService : GroupService,
    private toastr: ToastrService,
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.loadLatestTicket();
    this.socketService.missionAnnounced$.subscribe(
      mission => {
        if(mission.action == 'reloadLastestTicket') {
          this.loadLatestTicket();
        }
      })
  }

  openTicket(ticket: any) {
    this.userService.find({ _id: ticket.requester_id }).toPromise().then(res => {
      if (res.status == 200 && res.error == false) {
        ticket.request = res.data;
        this.socketService.opentab(ticket, 'ticket', 'edit');
      }
    })
  }

  loadLatestTicket() {
    this.ticketService.list({ limit: 3 }).toPromise().then(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.tickets;
      }
    })
  }

  // contentChildren are set
  ngAfterContentInit() {
    // get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);

    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first, 0, true);
    }
  }

  openTab(title: string, template, data: any, isCloseable = false) {
    // get a component factory for our TabComponent
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
      TabComponent
    );

    // fetch the view container reference from our anchor directive
    const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;

    // alternatively...
    // let viewContainerRef = this.dynamicTabPlaceholder;

    // create a component instance
    const componentRef = viewContainerRef.createComponent(componentFactory);

    // set the according properties on our component instance
    const instance: TabComponent = componentRef.instance as TabComponent;
    instance.title = title;
    instance.template = template;
    instance.dataContext = data;
    instance.tabIndex = this.dynamicTabs.length;
    instance.isCloseable = isCloseable;

    // remember the dynamic component for rendering the
    // tab navigation headers
    this.dynamicTabs.push(componentRef.instance as TabComponent);
    // set it active
    this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1], this.dynamicTabs.length);
  }

  selectTab(tab: TabComponent, index, is_load = false) {
    // deactivate all tabs
    this.tabs.toArray().forEach(tab => (tab.active = false));
    this.dynamicTabs.forEach(tab => (tab.active = false));
    if (tab.title != 'Thêm') {
      $('.tab-content').css('display', 'block');
      $('.main-content').css('display', 'none');
    } else {
      $('.tab-content').css('display', 'none');
      $('.main-content').css('display', 'block');
    }

    // activate the tab the user has clicked on.
    tab.active = true;
    if (index == undefined && !is_load && tab.title == 'Thêm') {
      this.clickTabFirst.emit(true);
    }
  }

  trackByFn(i: number) {
    return i;
  }

  closeTab(tab: TabComponent) {
    if (tab.dataContext.action == 'ring') {
      return;
    }
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        // remove the tab from our array
        this.dynamicTabs.splice(i, 1);

        // destroy our dynamically created component again
        let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        // // let viewContainerRef = this.dynamicTabPlaceholder;
        viewContainerRef.remove(i);

        // set tab index to 1st one
        console.log(i);
        if (i == 0)
          this.selectTab(this.tabs.first, 0);
        else this.selectTab(this.dynamicTabs[i - 1], i - 1);
        break;
      }
    }
  }

  closeActiveTab() {
    const activeTabs = this.dynamicTabs.filter(tab => tab.active);
    if (activeTabs.length > 0) {
      // close the 1st active tab (should only be one at a time)
      this.closeTab(activeTabs[0]);
    }
  }

  openNewTab(tab: TabComponent) {
    event.stopPropagation();
    this.selectTab(tab, undefined);
  }

  openModal(template: TemplateRef<any>) {
    event.stopPropagation();
    this.model = {
      role: null,
      group_id: '', // Gán mặc định bằng outbound
    };
    this.modelOrganize = {};
    this.message = null;
    this.getGroup();
    let config = {
      backdrop:true,
      ignoreBackdropClick: true,
      keyboard: false
    }
    this.modalRef = this.modalService.show(template, config);
  }

  getGroup(){
    this.is_load_data = true;
    this.groupService.allGroup().subscribe(res => {
      let groupList = [];
      res.data.forEach((c: any) => {
          groupList.push({
              text: c.name,
              id: c.id,
          });
      });
      this.allGroup = groupList;
      this.is_load_data = false;
    });
  }

  changedGroup($event){
    if(!this.is_load_data){
      this.model['group_id'] = $event.value;
    }
    
  }

  addUser() {
    this.userService.create(this.model).subscribe(res => {
      if (res.status == 200 && res.error == false) {
          this.modalRef.hide();
          this.toastr.success('Lưu thành công', '', {
            timeOut: 1000,
            positionClass: 'toast-bottom-right'
        });
      } else {
          this.toastr.error('Lưu không thành công', '', {
              timeOut: 1000,
              positionClass: 'toast-bottom-right'
          });
      }
    }, error => {
      this.message = { class: "alert dark alert-danger", content: error.message };
      setTimeout(() => this.message = null, 3000);
    })
  }

  addOrganize() {
    this.organizeService.create(this.modelOrganize).subscribe(res => {
        if (res.status == 200 && res.error == false) {
            this.modalRef.hide();
            this.toastr.success('Lưu thành công', '', {
              timeOut: 1000,
              positionClass: 'toast-bottom-right'
          });
        } else {
            this.toastr.error('Lưu không thành công', '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
            });
        }
    }, error => {
      this.message = { class: "alert dark alert-danger", content: error.message };
      setTimeout(() => this.message = null, 3000);
    })
}
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/tabs/tabs.component.ts